module.exports = __webpack_public_path__ + "img/credit_pad.2683b3db.svg";